<template>
  <vbt-error-boundary
    :error="$attrs.error"
    :no-content="!orderItems.length"
  >
    <vbt-table
      :headers="headers"
      :items="orderItems"
      show-paginator
    >
      <template #orderId="{ item: { orderId } }">
        <router-link
          v-if="orderId"
          :to="{
            name: 'order',
            params: { id: orderId },
            query: { suffix },
          }"
          class="info--text"
        >
          {{ orderId }}
        </router-link>
      </template>
      <template #uv="{ item: { uvFront, uvBack } }">
        <v-layout column>
          <v-layout v-show="uvFront">
            Front: {{ uvFront }}
          </v-layout>
          <v-layout v-show="uvBack">
            Back: {{ uvBack }}
          </v-layout>
        </v-layout>
      </template>
    </vbt-table>
  </vbt-error-boundary>
</template>

<script>
import { mapState } from 'vuex';

import { namespace as LocationsNamespace } from '@store/modules/locations.types';

const headers = Object.freeze([
  { text: 'Order ID', value: 'orderId' },
  { text: 'Outer ID', value: 'outerId' },
  { text: 'Product Type', value: 'productType' },
  { text: 'Substrate', value: 'substrate' },
  { text: 'Count', value: 'count' },
  { text: 'Quantity', value: 'quantity' },
  { text: 'Quantity Remaining', value: 'quantityRemaining' },
  { text: 'UV', value: 'uv' },
]);

export default {
  name: 'KernelPressSheetOrderItemsList',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({ headers }),
  computed: {
    ...mapState(LocationsNamespace, ['suffix']),
    orderItems() {
      return this.items.reduce((acc, item) => {
        const signature = (item?.orderItem?.signatures || [])
          .find(({ number }) => number === item.signatureNumber) || {};
        acc.push({
          orderId: item.orderId,
          outerId: item?.orderItem?.outerId,
          productType: item?.orderItem?.productType,
          substrate: signature?.substrate,
          count: item.count,
          quantity: item?.orderItem?.quantity,
          quantityRemaining: signature?.quantityRemaining,
          uvBack: signature?.uvBack,
          uvFront: signature?.uvFront,
        });
        return acc;
      }, []);
    },
  },
};
</script>
